import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import {
  FaArrowRight,
  FaBalanceScale,
  FaBirthdayCake,
  FaBriefcase,
  FaBuilding,
  FaBusinessTime,
  FaCalendarAlt,
  FaCheckSquare,
  FaClipboardCheck,
  FaClipboardList,
  FaClock,
  FaCog,
  FaDownload,
  FaEdit,
  FaEnvelopeSquare,
  FaEye,
  FaFile,
  FaFileAlt,
  FaFilePdf,
  FaGraduationCap,
  FaHome,
  FaInfoCircle,
  FaListAlt,
  FaListUl,
  FaLock,
  FaSignOutAlt,
  FaSuitcase,
  FaTasks,
  FaTicketAlt,
  FaTimesCircle,
  FaTrash,
  FaUserCircle,
  FaUserCog,
  FaUserTie,
  FaUsers,
  FaWindowClose,
  FaBan,
} from 'react-icons/fa';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > .fa': {
      margin: theme.spacing(2),
    },
  },
}));

export default function FontAwesomeIconComponent(props) {
  useStyles();

  const normalizedClasses = (props.classes || "").trim().replace(/\s+/g, " ");
  const iconMap = {
    "fa fa-arrow-right": FaArrowRight,
    "fa fa-business-time": FaBusinessTime,
    "fa fa-cog": FaCog,
    "fa fa-envelope-square": FaEnvelopeSquare,
    "fa fa-file": FaFile,
    "fa fa-file-pdf": FaFilePdf,
    "fa fa-graduation-cap": FaGraduationCap,
    "fa fa-home": FaHome,
    "fa fa-info-circle": FaInfoCircle,
    "fa fa-lock": FaLock,
    "fa fa-suitcase": FaSuitcase,
    "fa fa-tasks": FaTasks,
    "fa fa-trash": FaTrash,
    "fa fa-download": FaDownload,
    "fa fa-edit": FaEdit,
    "fa fa-eye": FaEye,
    "fa fa-window-close": FaWindowClose,
    "far fa-calendar-alt": FaCalendarAlt,
    "far fa-check-square": FaCheckSquare,
    "far fa-file-alt": FaFileAlt,
    "far fa-times-circle": FaTimesCircle,
    "fas fa-balance-scale": FaBalanceScale,
    "fas fa-briefcase": FaBriefcase,
    "fas fa-building": FaBuilding,
    "fas fa-clipboard-check": FaClipboardCheck,
    "fas fa-clipboard-list": FaClipboardList,
    "fas fa-clock": FaClock,
    "fas fa-file-alt": FaFileAlt,
    "fas fa-list-alt": FaListAlt,
    "fas fa-list-ul": FaListUl,
    "fas fa-sign-out-alt": FaSignOutAlt,
    "fas fa-ticket-alt": FaTicketAlt,
    "fas fa-user-circle": FaUserCircle,
    "fas fa-user-cog": FaUserCog,
    "fas fa-users": FaUsers,
    "fas fa-user-tie": FaUserTie,
    "fas fa-window-close": FaWindowClose,
    "fas fa-times-circle": FaTimesCircle,
    "fa fa-ban": FaBan,
  };

  const iconStyle = {
    ...(props.colorName
      ? { color: 'var(--hrms-primary-blue-end, #036dda)' }
      : null),
    ...(props.style || {})
  };

  const LocalIcon = iconMap[normalizedClasses];

  if (LocalIcon) {
    return (
      <LocalIcon
        className={normalizedClasses}
        style={iconStyle}
        size={props.fontSize ? 18 : 20}
      />
    );
  }

  return (
    <Icon className={props.classes} fontSize={(props.fontSize) ? "small" : ""} style={iconStyle} />
  );
}
